import useT from "utils/useT"

const SocialLinks = () => {
  const t = useT()
  return (
    <>
      <div className="card card-style">
        <div className="content mb-0">
          <h3 dir="auto" className="font-700">
            {t.contact.followUs}
          </h3>
          <p dir="auto" className="pb-0 mb-0">
            {t.contact.followUsSub}
          </p>
          <div className="list-group list-custom-small">
            <a href="mailto:info@appollow.net">
              <i className="fa font-14 fa-envelope color-mail"></i>
              <span>info@appollow.net</span>
              <span className="badge bg-highlight color-white">
                {t.contact.tapToEmail}
              </span>
              <i className="fa fa-angle-right"></i>
            </a>
            <a href="https://www.facebook.com/Appollowapp/">
              <i className="fab font-14 fa-facebook color-facebook"></i>
              <span>Appollow</span>
              <i className="fa fa-link"></i>
            </a>
            <a href="https://twitter.com/Appollowapp">
              <i className="fab font-14 fa-twitter-square color-twitter"></i>
              <span>@Appollowapp</span>
              <i className="fa fa-link"></i>
            </a>
            <a href="https://instagram.com/Appollowapp">
              <i className="fab font-14 fa-instagram color-instagram color-twitter"></i>
              <span>@Appollowapp</span>
              <i className="fa fa-link"></i>
            </a>
            <a
              href="https://linkedin.com/company/Appollowapp"
              className="border-0"
            >
              <i className="fab font-14 fa-linkedin color-linkedin"></i>
              <span>@Appollowapp</span>
              <i className="fa fa-link"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default SocialLinks
